import { Base } from '@models/base.model';
import { PageObject } from '@models/page-object.model';
import { serializable, deserialize } from 'serializr';

export class ByCustomFieldsCount extends Base implements PageObject {
  @serializable
  public customFieldValue: string;
  @serializable
  public count: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(ByCustomFieldsCount, input));
  }
}
